import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=57df1a28&scoped=true"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=57df1a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df1a28",
  null
  
)

export default component.exports